import { Component, computed, inject, input, output } from '@angular/core';
import { OnboardingCredentials } from './models/credentials';
import { LinkComponent } from 'src/app/controls/components/basic/link/link.component';
import { CredentialsStatus, TransportType } from '../../models/partner-onboarding';
import { GenericModalService } from 'src/app/shared/generic-modal/generic-modal.service';
import { PartnerPortalService } from '../../services/partner-portal.service';
import { SecretService } from 'src/app/shared/secret/services/secret.service';

@Component({
  selector: 'app-onboarding-credentials',
  standalone: true,
  imports: [LinkComponent],
  templateUrl: './onboarding-credentials.component.html',
  styleUrl: './onboarding-credentials.component.scss'
})
export class OnboardingCredentialsComponent {
  modalService = inject(GenericModalService);
  private secretService = inject(SecretService);
  partnerPortalService = inject(PartnerPortalService);

  credentials = input<OnboardingCredentials>(null);
  disabled = input<boolean>(false);
  credentialsStatus = input<CredentialsStatus>(null);
  transportType = input.required<TransportType>()
  requestCredentialsClicked = output<TransportType>();
  showCredentialsClicked = output<TransportType>();

  requested = computed(() => this.credentialsStatus() === CredentialsStatus.Requested);
  hasCredentials = computed(() => this.credentials() !== null)

  requestCredentials() {
    if (this.transportType() === TransportType.IntegratedFTP) {
      console.log('Request Integrated FTP credetials');
    }
    else if (this.transportType() === TransportType.FTPCustomerEndpoint || this.transportType() === TransportType.SFTPCustomerEndpoint) {
      console.log('Request FTP/SFTP credetials');
    }

    console.log('Request credentials: ' + this.transportType());
    this.requestCredentialsClicked.emit(this.transportType());
  }

  showCredentials() {
    console.log('Show credentials: ' + this.transportType());
    this.showCredentialsClicked.emit(this.transportType());
  }
}
